import { render, staticRenderFns } from "./ConfigApp.vue?vue&type=template&id=16466114&"
import script from "./ConfigApp.vue?vue&type=script&lang=js&"
export * from "./ConfigApp.vue?vue&type=script&lang=js&"
import style0 from "./ConfigApp.vue?vue&type=style&index=0&id=16466114&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports